module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_statistics_and_metrics.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_statistics_and_metrics.png
// module id = A4nT
// module chunks = 0